import Styled from 'styled-components';

export const SectionHeader = Styled.div`
  display: flex;
  align-items: center;
  padding: 0.75em 1em 0.5em;
  background: ${({ theme: { banner }}) => banner.sectionBackground};
`;
